<div *ngIf="!addresses" class="block address" [ngClass]="type">
    <div class="noaddress">
        <div class="subtitle">{{ titleCaption | translate }}</div>
        <div class="icon" (dblclick)="markerDoubleClick.emit(type)">
            <i class="fa fa-map-marker"></i>
        </div>
    </div>
    <div class="address">
        <span class="pre-tags-strip">@</span>
        <shared-tags-strip-component class="line tags" [uniqueString]="skinAddress">
        </shared-tags-strip-component>
        <div class="line useraddress" [ngClass]="type + 'UserAddress'">
            <shared-copyclipboard [value]="descriptionShort">{{descriptionShort}}</shared-copyclipboard>
        </div>
        <div class="line realaddress" [ngClass]="type + 'RealAddress'">
            <shared-copyclipboard [value]="formattedAddress">{{formattedAddress}}</shared-copyclipboard>
        </div>
    </div>
</div>
<div *ngIf="addresses" class="block address" [ngClass]="type">
    <div class="subtitle">{{ titleCaption | translate }}</div>
    <span class="multiaddress" *ngFor="let address of addresses">
        <div class="icon" (dblclick)="manualAddressMarkerDoubleClick.emit(address)">
            <i class="fa fa-map-marker"></i>
        </div>
        <div class="address">
            <span class="pre-tags-strip">@</span>
            <shared-tags-strip-component class="line tags" [uniqueString]="address.skin">
            </shared-tags-strip-component>
            <div class="line realaddress" [ngClass]="type + 'RealAddress'">
                <shared-copyclipboard [value]="address.formattedAddress">{{address.formattedAddress}}</shared-copyclipboard>
            </div>
        </div>
    </span>
</div>